var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMlflowDisable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2776_28960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6613 8.08929C19.9775 4.80629 13.6005 5.45179 9.66715 9.60706C5.73376 13.7623 5.42881 20.1756 8.95014 24.6866L12.4659 22.1015C10.7207 19.9329 10.3663 16.9559 11.5533 14.4369C12.7403 11.9179 15.2599 10.3 18.0404 10.2713L17.9573 13.0232L24.6613 8.08929Z",
    fill: "#929292",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2613 10.6576C27.1447 10.4964 27.0226 10.3379 26.8978 10.1851L23.5125 12.6868C25.4236 14.8053 25.9194 17.8486 24.7799 20.466C23.6404 23.0833 21.0767 24.7898 18.2264 24.8283L18.3097 22.0792L11.5308 27.0826C16.1764 30.2164 22.3984 29.5523 26.2806 25.5084C30.1629 21.4645 30.5825 15.2105 27.2752 10.6826L27.2613 10.6576Z",
    fill: "#929292",
    stroke: "none"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2776_28960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "white",
    transform: "translate(6.5 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMlflowDisable);
export default __webpack_public_path__ + "static/media/mlflow-disable.6fb10eaeb0ef9bb93fe6f38720730d60.svg";
export { ForwardRef as ReactComponent };